export const noAccessUserSave: string =
  'You do not have access to view records owned by the user selected. You will not be able to view this record after saving.'
export const noAccessSalesTeamSave: string =
  'You are assigning this record to a sales team that you do not have access to. You will not be able to view it after saving.'
export const noAccessUserReassign: string =
  'You do not have access to view records owned by the user selected.  You will not be able to view this record after re-assigning it.'
